<h3>Datenschutzerklärung</h3>

<p>
Diese Datenschutzerklärung soll die Nutzer dieser Website über die Art, den Umfang und den Zweck der Erhebung und
  Verwendung personenbezogener Daten durch den Websitebetreiber informieren.
</p>
<p>
Der Websitebetreiber nimmt Ihren Datenschutz sehr ernst und behandelt Ihre personenbezogenen Daten vertraulich und
  entsprechend der gesetzlichen Vorschriften. Da durch neue Technologien und die ständige Weiterentwicklung dieser
  Webseite Änderungen an dieser Datenschutzerklärung vorgenommen werden können, empfehlen wir Ihnen sich die
  Datenschutzerklärung in regelmäßigen Abständen wieder durchzulesen.
</p>
<p>
  Wir weisen darauf hin, dass die Datenübertragung im Internet
  (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser
  Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
</p>

<mat-card>
  <mat-card-header>
    <mat-card-title><h4>Cookies</h4></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      Diese Website verwendet Cookies. Dabei handelt es sich um kleine Textdateien, welche auf
      Ihrem Endgerät gespeichert werden. Ihr Browser greift auf diese Dateien zu. Durch den
      Einsatz von Cookies erhöht sich die Benutzerfreundlichkeit und Sicherheit dieser Website.
    </p>
    <p>
      Gängige Browser bieten die Einstellungsoption, Cookies nicht zuzulassen. Hinweis: Es ist
      nicht gewährleistet, dass Sie auf alle Funktionen dieser Website ohne Einschränkungen
      zugreifen können, wenn Sie entsprechende Einstellungen vornehmen.
    </p>
  </mat-card-content>
</mat-card>
<br>

<mat-card>
  <mat-card-header>
    <mat-card-title><h4>Erfassung und Verarbeitung personenbezogener Daten</h4></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      Der Websitebetreiber erhebt, nutzt und gibt Ihre personenbezogenen Daten nur dann weiter, wenn dies im gesetzlichen
      Rahmen erlaubt ist oder Sie in die Datenerhebung einwilligen.
    </p>
    <p>
      Als personenbezogene Daten gelten sämtliche Informationen, welche dazu dienen, Ihre Person zu bestimmen und welche
      zu Ihnen zurückverfolgt werden können – also beispielsweise Ihr Name, Ihre E-Mail-Adresse und Telefonnummer.
    </p>
    <p>
      Diese Website können Sie auch besuchen, ohne Angaben zu Ihrer Person zu machen.
      Zur Verbesserung unseres Online-Angebotes speichern wir jedoch (ohne Personenbezug) Ihre Zugriffsdaten auf diese
      Website. Zu diesen Zugriffsdaten gehören z. B. die von Ihnen angeforderte Datei oder der Name Ihres Internet-Providers.
      Durch die Anonymisierung der Daten sind Rückschlüsse auf Ihre Person nicht möglich.
    </p>

    <h5>Benutzerkonto</h5>
    Um über dieses Angebot Buchungen tätigen zu können, muss jeder Kunde ein
    passwortgeschütztes Kundenkonto einrichten. Dieses beinhaltet eine Übersicht über
    getätigte Buchungen und aktive Buchungsvorgänge.
    Der Betreiber übernimmt keine Haftung für Passwortmissbrauch, sofern dieser nicht von dem
    Betreiber selbst verursacht wurde.

    <h5>Bestellvorgang</h5>
    Sämtliche Daten, welche im Rahmen einer Buchung von den Kunden eingegeben werden, werden gespeichert. Dazu gehören:
    <ul>
      <li>Name und Vorname der buchenden Person sowie weiterer Teilnehmer</li>
      <li>Geburtsdatum der buchenden Person sowie weiterer Teilnehmer</li>
      <li>Adresse</li>
      <li>E-Mail-Adresse</li>
      <li>Telefon/Handy Nummer</li>
      <li>Zahldaten</li>
    </ul>

    <h5>Weitergabe von Daten an Dritte und Drittanbieter</h5>
    <p>
    Jene Daten, welche zur Buchung, Bezahlung oder Abwicklung einer Reise zwingend notwendig sind,
    werden an dritte Dienstleister weitergegeben. Sowie die Aufbewahrung Ihrer Daten nicht
    mehr erforderlich oder gesetzlich geboten ist, werden diese gelöscht.
    </p>

    <h5>Umgang mit Kontaktdaten</h5>
    <p>
    Nehmen Sie mit uns als Websitebetreiber durch die angebotenen Kontaktmöglichkeiten
    Verbindung auf, werden Ihre Angaben gespeichert, damit auf diese zur Bearbeitung und
    Beantwortung Ihrer Anfrage zurückgegriffen werden kann. Ohne Ihre Einwilligung werden
    diese Daten nicht an Dritte weitergegeben.
    </p>
  </mat-card-content>
</mat-card>
<br>

<mat-card>
  <mat-card-header>
    <mat-card-title><h4>Facebook-Plugins</h4></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      Auf unseren Seiten sind Plugins des
      sozialen Netzwerks Facebook, Anbieter Facebook Inc., 1 Hacker Way, Menlo Park, California 94025,
      USA, integriert. Die Facebook-Plugins erkennen Sie an dem Facebook-Logo oder dem "Like-Button"
      ("Gefällt mir") auf unserer Seite. Eine Übersicht über die Facebook-Plugins finden Sie
      hier: <a href="http://developers.facebook.com/docs/plugins/">
        http://developers.facebook.com/docs/plugins/</a>.
    </p>
    <p>Wenn Sie unsere Seiten besuchen, wird
      über das Plugin eine direkte Verbindung zwischen Ihrem Browser und dem Facebook-Server
      hergestellt. Facebook erhält dadurch die Information, dass Sie mit Ihrer IP-Adresse unsere Seite
      besucht haben. Wenn Sie den Facebook "Like-Button" anklicken während Sie in Ihrem Facebook-
      Account eingeloggt sind, können Sie die Inhalte unserer Seiten auf Ihrem Facebook-Profil verlinken.
      Dadurch kann Facebook den Besuch unserer Seiten Ihrem Benutzerkonto zuordnen. Wir weisen darauf
      hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren
      Nutzung durch Facebook erhalten. Weitere Informationen hierzu finden Sie in der
      Datenschutzerklärung von Facebook unter <a href="http://de-de.facebook.com/policy.php">http://de-
        de.facebook.com/policy.php</a>.
    </p>
    <p>Wenn Sie nicht wünschen, dass Facebook den Besuch
      unserer Seiten Ihrem Facebook-Nutzerkonto zuordnen kann, loggen Sie sich bitte aus Ihrem Facebook-
      Benutzerkonto aus.
    </p>
  </mat-card-content>
</mat-card>
<br>

<mat-card>
  <mat-card-header>
    <mat-card-title><h4>SSL-Verschlüsselung</h4></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      Um Ihre übermittelten Daten bestmöglich zu schützen nutzen die Websitebetreiber eine SSL-Verschlüsselung.
      Sie erkennen derart verschlüsselte Verbindungen an dem Präfix “https://“ im Seitenlink in der Adresszeile
      Ihres Browsers. Unverschlüsselte Seite sind durch „http://“ gekennzeichnet.
    </p>
    <p>
    Sämtliche Daten, welche Sie an diese Website übermitteln – etwa bei Anfragen oder Logins
    – können dank SSL-Verschlüsselung nicht von Dritten gelesen werden.
    </p>
  </mat-card-content>
</mat-card>
<br>

<mat-card>
  <mat-card-header>
    <mat-card-title><h4>Rechte des Nutzers</h4></mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
    Sie haben als Nutzer das Recht, auf Antrag eine kostenlose Auskunft darüber zu erhalten, welche personenbezogenen Daten
    über Sie gespeichert wurden. Sie haben außerdem das Recht auf Berichtigung falscher Daten und auf die Verarbeitungseinschränkung
    oder Löschung Ihrer personenbezogenen Daten. Falls zutreffend, können Sie auch Ihr Recht auf Datenportabilität geltend machen.
    Sollten Sie annehmen, dass Ihre Daten unrechtmäßig verarbeitet wurden, können Sie eine Beschwerde bei der zuständigen
    Aufsichtsbehörde einreichen.
    </p>

    <h5>Löschung von Daten</h5>
    <p>
    Sofern Ihr Wunsch nicht mit einer gesetzlichen Pflicht zur Aufbewahrung von Daten (z. B. Vorratsdatenspeicherung)
    kollidiert, haben Sie ein Anrecht auf Löschung Ihrer Daten. Von uns gespeicherte Daten werden, sollten sie für ihre
    Zweckbestimmung nicht mehr vonnöten sein und es keine gesetzlichen Aufbewahrungsfristen geben, gelöscht. Falls eine
    Löschung nicht durchgeführt werden kann, da die Daten für zulässige gesetzliche Zwecke erforderlich sind, erfolgt
    eine Einschränkung der Datenverarbeitung. In diesem Fall werden die Daten gesperrt und nicht für andere Zwecke verarbeitet.
    </p>

    <h5>Widerspruchsrecht</h5>
    <p>
    Nutzer dieser Webseite können von ihrem Widerspruchsrecht Gebrauch machen und der Verarbeitung ihrer personenbezogenen
    Daten zu jeder Zeit widersprechen.
    </p>
    <p>
    Wenn Sie eine Berichtigung, Sperrung, Löschung oder Auskunft über die zu Ihrer Person gespeicherten personenbezogenen
      Daten wünschen oder Fragen bzgl. der Erhebung, Verarbeitung oder Verwendung Ihrer personenbezogenen Daten haben oder
      erteilte Einwilligungen widerrufen möchten, wenden Sie sich bitte an folgende E-Mail-Adresse: info@darwins-reisen.de
    </p>
  </mat-card-content>
</mat-card>
